import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const BannerWrapper = styled(Box)`
  width: 100%;
  flex-shrink: 0;
`;

export const BannerInner = styled(Box)`
  width: ${({ theme }) => theme.defaultContentWidth};
  align-self: center;
  flex-shrink: 0;
  min-height: max-content;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.spacing12};
`;
